import { render, staticRenderFns } from "./ChoiceGroups.vue?vue&type=template&id=1a8f73ee&scoped=true"
import script from "./ChoiceGroups.vue?vue&type=script&lang=js"
export * from "./ChoiceGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8f73ee",
  null
  
)

export default component.exports